export default defineNuxtRouteMiddleware((to, from) => {
    const { getMdsf } = useAuth()
    const isMds = getMdsf()

    if (isMds) {
        throw createError({
            statusCode: 404,
            statusMessage: 'Page Not Found',
            fatal: true
        })
    }
})